var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.314 813.752h-124.718c-112.336 0-209.849-74.86-239.41-181.088-3.749-13.473 4.134-27.435 17.607-31.184s27.435 4.134 31.184 17.607c23.492 84.419 101.129 144.020 190.619 144.020h124.144l-49.58-52.776c-9.576-10.193-9.075-26.218 1.117-35.794s26.218-9.075 35.794 1.117l92.461 98.421c9.576 10.193 9.075 26.218-1.117 35.794l-98.421 92.461c-10.193 9.576-26.218 9.075-35.794-1.117s-9.075-26.218 1.117-35.794l54.997-51.667zM348.179 38.173v512.065h512.228v-512.065h-512.228zM898.061 25.821v540.216c0 13.985-11.337 25.323-25.323 25.323h-540.216c-13.985 0-25.323-11.337-25.323-25.323v-540.216c0-13.985 11.337-25.323 25.323-25.323h540.216c13.985 0 25.323 11.337 25.323 25.323z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.04daf2ccada75c5eecba31621d3c15c3.svg";
export { ForwardRef as ReactComponent };